import { compareCodeUnits } from './compare';

/** Two sort keys compared like lodash `sortBy`: numbers before `NaN`, text by code units. */
const compareKeys = (a: string | number, b: string | number): number => {
  if (typeof a === 'number' && typeof b === 'number') {
    const aNaN = Number.isNaN(a);
    const bNaN = Number.isNaN(b);
    if (aNaN && bNaN) return 0;
    if (aNaN) return 1;
    if (bNaN) return -1;
    return a - b;
  }
  return compareCodeUnits(a, b);
};

/**
 * Stable sort on one key (lodash `sortBy` semantics):
 * equal keys keep their order, `reverse` flips the whole result.
 */
export const sortByKey = <Item>(
  items: readonly Item[],
  key: (item: Item) => string | number,
  reverse = false,
): Item[] => {
  const sorted = items
    .map((item, index) => ({ item, index, key: key(item) }))
    .sort((a, b) => compareKeys(a.key, b.key) || a.index - b.index)
    .map(({ item }) => item);
  return reverse ? sorted.reverse() : sorted;
};
